import { render, staticRenderFns } from "./IconChevronUp.vue?vue&type=template&id=d6289a78&"
import script from "./IconChevronUp.vue?vue&type=script&lang=ts&"
export * from "./IconChevronUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports